import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './providers/auth.service';
import { UsersService } from './services/users.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'FlandresApp';

  user: Observable<firebase.User>;
  isLogged: Boolean;
  pseudo: String;
  email: String;


  constructor(public authService: AuthService,  private usersService : UsersService, public afAuth: AngularFireAuth, private router: Router) {



    this.user = this.authService.afAuth.authState;
    //console.log(this.authService.afAuth.auth.currentUser);
    this.user.subscribe( (auth) => {

      if (auth) {

        firebase.auth().onAuthStateChanged((userFire:firebase.User) => {
          if (userFire) {
            firebase.auth().currentUser.getIdToken(true).then((idToken) => {
    
    
            this.usersService.checkUserRight(idToken, userFire.uid).subscribe((response: boolean) =>  {
                  if(response == true)
                  {
                    this.isLogged = true;
                    this.pseudo = auth.displayName;
                    this.email = auth.email;
                   
                    //console.log(auth);
                    this.router.navigate(['dashboard']);
                  }
                  else{
                   
                    this.isLogged = false;
                    this.pseudo = '';
                    this.email = '';
                    //this.authService.logout();
                    this.router.navigate(['']);
                  }
  
              });
            })
          }
        })



      } else {
   
        this.isLogged = false;
        this.pseudo = '';
        this.email = '';
        this.router.navigate(['']);
      } 
    });
  }

}
